import React from 'react';

// Estilo de la etiqueta en el detalle del cliente (.tramite-etiqueta en TramitesCliente.css): azul
// con el ícono de etiqueta, para que se reconozca como "la misma etiqueta" en las dos pantallas.
const ESTILO_ETIQUETA = {
    color: '#1d4ed8',
    background: 'rgba(37, 99, 235, 0.08)',
    border: '1px solid rgba(37, 99, 235, 0.2)',
    fontWeight: 500,
    // Una etiqueta puede tener hasta 100 caracteres: se corta con "…" en vez de empujar los botones
    // del encabezado; el texto completo queda en el tooltip.
    maxWidth: 'min(28rem, 100%)',
};

/**
 * La etiqueta libre de un trámite (la que se carga desde la tarjeta del trámite en el detalle del
 * cliente), para mostrarla junto al cartel del tipo en el encabezado de cada detalle de trámite.
 *
 * Es solo lectura: se edita desde el detalle del cliente o desde el formulario de edición del
 * trámite. Sin etiqueta no muestra nada, así que se puede poner siempre, sin condicionales.
 */
export default function EtiquetaTramite({ etiqueta }) {
    const texto = typeof etiqueta === 'string' ? etiqueta.trim() : '';
    if (!texto) return null;

    return (
        <span
            className="badge rounded-pill fs-6 px-3 d-inline-flex align-items-center gap-2"
            style={ESTILO_ETIQUETA}
            title={`Etiqueta del trámite: ${texto}`}
            data-testid="etiqueta-tramite"
        >
            <i className="bi bi-tag-fill" aria-hidden="true" />
            <span className="text-truncate">{texto}</span>
        </span>
    );
}
